<template>
    <div  class="box">
       <form  method="post">
          <Navigation></Navigation> 
          <div class="register">
            <h1 style="text-align: center;font-size: 26px;margin-top: 33px;margin-bottom: 30px;color: #806b45;">注册会员</h1>
            <hr>
            <form class="formStyle">
                <label style="position: relative;">
                    <strong class="fontSize14">
                        <span class="fontColorRed">*</span>
                        <span class="fontColorBlack">用户名</span>  
                    </strong>
                    <input type="text" id="username"  placeholder="请输入用户名" v-model="registerForm.username" @blur="check(registerForm.username)">
                    <!-- <span v-show="!registerForm.username" :class="{errorMsg:true}">{{ err.msg }}</span> -->
                </label>
                

                <label >
                    <strong class="fontSize14">
                        <span class="fontColorRed">*</span>
                        <span class="fontColorBlack">姓名</span> 
                        
                    </strong>
                    <input type="text" placeholder="请输入姓名" v-model="registerForm.realName">
                </label>

                <label >
                    <strong class="fontSize14">
                        <span class="fontColorRed">*</span>
                        <span class="fontColorBlack">手机号</span>
                        
                    </strong>
                    <input type="text" placeholder="请输入手机号" v-model="registerForm.mobile">

                </label>

                

                <label style="position: relative;">
                    <strong class="fontSize14">
                        <span class="fontColorRed">*</span>
                        <span class="fontColorBlack">短信验证码</span>   
                    </strong>
                    <input type="text" placeholder="请输入短信验证码" v-model="registerForm.mobileCode">
                    
                    <el-button 
                        :disabled="!canClick"
                        class="fontSize14 marginLeft smsCode"
                        @click="countdown">
                        {{content}}
                    </el-button>
                    
                </label>

                

                <el-row >
                    <el-button type="warning" class="registerButton" @click="register">
                        注册
                    </el-button>     
                </el-row>
            </form>
          </div>
          <!-- Form -->
            <el-dialog title="设置密码" :visible="dialogFormVisible" width="36%" :close-on-click-modal="!dialogFormVisible" top="20vh">
                <el-form :model="form">
                    <el-form-item label="密码" :label-width="formLabelWidth">
                        <el-input type="password" v-model="form.password" autocomplete="off" show-password class="inputWidth"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" :label-width="formLabelWidth">
                        <el-input type="password" v-model="form.rePassword" autocomplete="off" show-password class="inputWidth"></el-input>
                    </el-form-item>
                    <el-form-item label="企业" :label-width="formLabelWidth">
                        <el-select v-model="form.companyName" filterable placeholder="请选择">
                        <el-option
                        v-for="item in companyNameList"
                        :key="item.companyName"
                        :value="item.companyName">
                        </el-option>
                    </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="setUserPassword">确 定</el-button>
                </div>
                
            </el-dialog>
            
        </form>
   </div>
</template>

<script>
    import axios from 'axios';
    import Navigation from '../components/Navigation';
    export default{
       name:"Login",
       components:{Navigation},
       data(){
        return{
            err:{
                msg:"",
            },
            content:'发送验证码',
            canClick: true,
            refreshData: null,
            registerForm:{
                username:'',
                realName:'',
                mobile:'',
                mobileCode:''
            },
            dialogFormVisible: false,
            form: {
                password: '',
                rePassword: '',
                companyName:'',
                type:0
            },
            keyword:"",
            formLabelWidth: '120px',
            companyNameList:null,
            
        };
          
       },
       mounted(){
        this.searchCompanyNameList()
           
       },
        methods:{
            check(formItemName){
                if(formItemName==null || formItemName.trim().length ===0){
                    this.err.msg = "不能为空";
                }else{
                    this.err.msg = ""
                }
            },
            setUserPassword(){
                let {password,rePassword,type} = this.form
                let {mobile} = this.registerForm
                if(password.trim()==''){
                    this.ELMessage('密码不能为空','error');
                    return;
                }
                if(!(password.trim() === rePassword.trim())){
                    this.ELMessage('密码不一致','error');
                    return;
                }
                axios.put('http://localhost:8080/renren-admin/updatePassword',{
                    ...this.form,mobile
                })
                .then(
                   response => {
                       if(response.data.code == 0){
                            this.ELMessage("密码设置成功","success");
                            this.dialogFormVisible = false;
                            window.location.href="http://localhost:8001/#login"
                       }else{
                            this.ELMessage(response.data.msg);
                       }
                       
                   })
                .catch(
                    error => {
                        this.ELMessage(`请求异常：${error.message}`)
                    }
                )

            },
            countdown() {
                if(this.registerForm.mobile.trim()==''){
                    this.ELMessage('手机号不能为空');
                    return;
                }
                //发送验证码
                this.getSmsCode();
                let totalTime = 60;
                if (!this.canClick) return; //节流
                this.canClick = false;
                this.content = totalTime + "s后重新获取";
                this.refreshData = window.setInterval(() => {
                totalTime--;
                this.content = totalTime + "s后重新获取";
                if (totalTime <= 0) {
                    //当倒计时小于0时清除定时器
                    window.clearInterval(this.refreshData); //清除定时器
                    this.content = "发送验证码";
                    totalTime = 60;
                    this.canClick = true; //这里重新开启
                }
                }, 1000);
            },
            getSmsCode(){
                axios.post(`http://localhost:8080/renren-admin/user/smsCode/${this.registerForm.mobile}`)
                .then(response =>{
                       if(response.data.code == 0){
                        this.ELMessage("验证码发送成功","success");
                       }
                   })
                   .catch(error => {
                        this.ELMessage(`${error.message}`)
                    }
                )
            },
            register(){
                
                let {username,realName,mobile,mobileCode} =  this.registerForm
                //表单校验
                
                axios.post('http://localhost:8080/renren-admin/user/register',{
                    username,
                    realName,
                    mobile,
                    mobileCode
                }).then(
                    response =>{
                        if(response.data.msg == 'success'){
                            this.ELMessage(response.data.msg,'success');
                            this.dialogFormVisible = true;
                        
                        }else{
                            this.ELMessage(response.data.msg)
                        }
                    }
                ).catch(
                    error => {
                        this.ELMessage(error.message)
                    }
                )
            },
            ELMessage(msg,type){
                this.$message({
                    message: msg,
                    type: type == "success"?"success":"error"
                });
            },
            async searchCompanyNameList(){
                let result = await axios.get(`http://localhost:8080/renren-admin/enterprise/enterpriselibrary/companyList?companyName=${this.keyword}`)
                this.companyNameList=result.data.data;                
            }
        },
        beforeDestroy() {
        if (this.refreshData) {
            clearInterval(this.refreshData);
            this.refreshData = null;
        }
        }
    }
</script>

<style scoped>
.errorMsg{
    color: red;
    width: 100px;
    font-size: 14px;
    position: absolute;
    right: 10px;
    bottom:10px;
}
.inputWidth{
    width: 400px;
}
.floatLeft{
    float: left;
    margin-left: 11px;
}
.smsCode{
    width: 120px;
    color: #b29359;
    margin-top: 20px;
    position: absolute;
    right: 0px;
}
.formStyle{
    margin: 0 auto;
    width: 470px;
    height: 300px;
    text-align: right;
}
.marginLeft{
    margin-left: 0px;
}
.fontSize14{
    font-size: 14px;
}
.fontColorBlack{
    color: #17171a;
}
.fontColorRed{
    color: red;
}
.registerButton{
    width: 240px;
    height: 42px;
    background-color: #c6a66a;
    font-size: 16px;
    margin-right: 116px;
    margin-top: 20px;
}
hr{
    width: 700px;
    margin: 0 auto;
}
.box{
   width: 100%;
   height: 969px;
   /* background:  #f2f2f2; */
   background: url('../assets/img/login_bg2.jpg') no-repeat;
   background-size: 100%;
   overflow: hidden;
   position: relative;
}
.register{
    width: 800px;
    height: 520px;
    background-color: #fff; 
    top: 200px;
    left: 560px;
    position: absolute;
}

.register input{
    width: 356px;
    height: 42px;
    font-size: 14px;
    padding-left: 14px;
    margin-top: 20px;
    margin-left: 20px;
    outline: none;
    color: #8d8d99;
    background-color: #f4f4f4;
    border: 1px solid #d9d9d9;
    border-radius: 3px;
}
.register input:focus{
    background-color: #fff;
   border: 1px solid skyblue;
}
.register .with220{
    width: 220px;
}

#username{
    margin-top: 36px;
}


</style>


// WEBPACK FOOTER //
// src/pages/Register.vue